import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Divider,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
} from '@mui/material'
import { useEffect, useState } from 'react'
import { useFormikContext } from 'formik'
import { BsArrowUp, BsPrinter } from 'react-icons/bs'
import { MdDelete } from 'react-icons/md'
import { currencyMask } from '../../../../utils/masks'
import AutoComplete from '../../../../components/AutoComplete/AutoComplete'
import CurrencyField from '../../../../components/CurrencyField/CurrencyField'
import { setWarning } from '../../../../components/alerts'
import { useCheckin } from './CheckinContext'
import BotaoEstornos from '../../components/BotaoEstornos'

const ResumoFinal = ({ onImprimir, onSalvarRascunho, onExcluirRascunho }) => {
  const {
    values,
    errors,
    touched,
    isSubmitting,
    setFieldValue,
    submitForm,
    setSubmitting,
    handleChange,
  } = useFormikContext()
  const { getCalculos, isFinalizado, isRascunho, somenteLeitura } = useCheckin()
  const [totalEstornado, setTotalEstornado] = useState(0)

  const {
    saldoProposta,
    valorTotalTabelaBase,
    totalGeral,
    subTotalTerapias,
    subTotalProdutos,
    subTotalAdicionais,
  } = getCalculos(values)

  const pagamentoObrigatorio = totalGeral > 0 && values.snCobraCheckout !== 'S'
  const valorDesconto = Number(values.vlDesconto || 0)
  const totalPago = (values.formasPagamento || []).reduce(
    (acumulador, formaPagamento) =>
      acumulador + Number(formaPagamento?.vlPago || 0),
    0,
  )
  const isDisabled = isSubmitting || isFinalizado || somenteLeitura
  const isCampoFinanceiroDisabled = isDisabled || !pagamentoObrigatorio

  useEffect(() => {
    setFieldValue('vlTotal', totalGeral, false)
  }, [setFieldValue, totalGeral])

  return (
    <Paper
      sx={{
        borderRadius: 3,
        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ px: 2, pt: 2, pb: 1 }}>
        <Typography
          align="center"
          sx={{ fontWeight: 700, fontSize: 18, mb: 2 }}
        >
          Resumo Final
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <BsArrowUp
            style={{
              color: 'red',
              fontSize: 18,
              marginRight: 6,
              flexShrink: 0,
            }}
          />
          <Typography variant="body2" sx={{ flex: 1 }}>
            Total Proposta
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 700, ml: 2 }}>
            R$ {currencyMask(saldoProposta)}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <BsArrowUp
            style={{
              color: 'red',
              fontSize: 18,
              marginRight: 6,
              flexShrink: 0,
            }}
          />
          <Typography variant="body2" sx={{ flex: 1 }}>
            Total Terapias
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 700, ml: 2 }}>
            R$ {currencyMask(subTotalTerapias)}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <BsArrowUp
            style={{
              color: 'red',
              fontSize: 18,
              marginRight: 6,
              flexShrink: 0,
            }}
          />
          <Typography variant="body2" sx={{ flex: 1 }}>
            Total Produtos
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 700, ml: 2 }}>
            R$ {currencyMask(subTotalProdutos)}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <BsArrowUp
            style={{
              color: 'red',
              fontSize: 18,
              marginRight: 6,
              flexShrink: 0,
            }}
          />
          <Typography variant="body2" sx={{ flex: 1 }}>
            Total Adicionais
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 700, ml: 2 }}>
            R$ {currencyMask(subTotalAdicionais)}
          </Typography>
        </Box>

        <Divider sx={{ my: 1.5 }} />

        <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
          <Typography
            variant="body1"
            sx={{ flex: 1, fontWeight: 700, fontSize: 16 }}
          >
            SubTotal
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 700, fontSize: 16 }}>
            R$ {currencyMask(valorTotalTabelaBase)}
          </Typography>
        </Box>

        {valorDesconto > 0 && (
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
            <Typography variant="body2" sx={{ flex: 1, color: 'success.main' }}>
              Desconto
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontWeight: 700, ml: 2, color: 'success.main' }}
            >
              - R$ {currencyMask(valorDesconto)}
            </Typography>
          </Box>
        )}

        <Divider sx={{ my: 1.5 }} />

        <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
          <Typography
            variant="body1"
            sx={{ flex: 1, fontWeight: 700, fontSize: 16 }}
          >
            Total a Pagar
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 700, fontSize: 16 }}>
            R$ {currencyMask(totalGeral)}
          </Typography>
        </Box>

        {isFinalizado && (
          <Box
            sx={{
              bgcolor: '#e8f5e9',
              borderRadius: 1,
              p: 3,
              textAlign: 'center',
              mt: 2,
              mb: 1,
            }}
          >
            <Typography sx={{ fontWeight: 700, fontSize: 28, color: 'green' }}>
              {values.situacaoPedido === '1'
                ? 'Cobrar no Checkout'
                : `PAGO (R$ ${currencyMask(totalPago)})`}
            </Typography>
            {totalEstornado > 0 && (
              <>
                <Typography>
                  Estornado: R$ {currencyMask(totalEstornado)}
                </Typography>
                <Typography fontWeight={700}>
                  Valor líquido pago: R${' '}
                  {currencyMask(Math.max(0, totalPago - totalEstornado))}
                </Typography>
              </>
            )}
            <BotaoEstornos
              codigo="CtrlOrcamentoCheckin"
              idAtendimento={values.idAtendimento}
              habilitado={isFinalizado}
              temPagamento={totalPago > 0}
              onTotalEstornado={setTotalEstornado}
            />
          </Box>
        )}
      </Box>

      <Divider />

      <Box sx={{ px: 2, py: 2 }}>
        <FormControlLabel
          label="Cobrar no Checkout"
          disabled={isDisabled}
          control={
            <Checkbox
              color="primary"
              checked={values.snCobraCheckout === 'S'}
              onChange={(_, checked) =>
                setFieldValue('snCobraCheckout', checked ? 'S' : 'N')
              }
            />
          }
        />
        <AutoComplete
          InputLabelProps={{ shrink: true }}
          label="Forma de Pagamento"
          metodo="buscaFormaPagamento"
          multiple
          size="small"
          filterFunction={() => true}
          filterSelectedOptions={false}
          getOptionLabel={(v) => v?.[1] || ''}
          value={values?.acFormaPagamento ?? []}
          disabled={isCampoFinanceiroDisabled}
          onChange={(_, val) => {
            const opcoesSelecionadas = val?.map((item) => {
              const idFormaPagamento = item?.[0]?.[0]
              const unic = item?.[0]?.[1] || crypto.randomUUID()

              return [[idFormaPagamento, unic], ...item.slice(1)]
            })
            let valorJaDistribuido = 0
            const valorTratado = opcoesSelecionadas?.map((item) => {
              const idFormaPagamento = item?.[0]?.[0]
              const unic = item?.[0]?.[1]
              const existente = values?.formasPagamento?.find(
                (v) =>
                  v.unic === unic && v.idFormaPagamento === idFormaPagamento,
              )
              const vlPago = existente
                ? Number(existente.vlPago || 0)
                : Math.max(0, totalGeral - valorJaDistribuido)

              valorJaDistribuido += vlPago

              return {
                idFormaPagamento,
                vlPago,
                qtParcelas: existente ? existente.qtParcelas : item?.[4],
                isParcelas: existente ? existente.isParcelas : item?.[3],
                unic,
              }
            })

            const totalPago = valorTratado?.reduce(
              (acc, v) => acc + (v.vlPago || 0),
              0,
            )

            if (
              totalPago > totalGeral &&
              opcoesSelecionadas.length >=
                (values?.acFormaPagamento?.length || 0)
            ) {
              setWarning(
                'O valor total das formas de pagamento não pode ultrapassar o total a pagar',
              )
            }

            setFieldValue('formasPagamento', valorTratado)
            setFieldValue('acFormaPagamento', opcoesSelecionadas)
          }}
          textFieldProps={{
            error: !!errors?.acFormaPagamento,
            helperText: errors?.acFormaPagamento,
            variant: 'outlined',
            size: 'small',
          }}
        />

        {values?.acFormaPagamento?.map((item, index) => (
          <Grid
            container
            key={item?.[0]?.[1] || index}
            spacing={1}
            alignItems="center"
            sx={{ mt: 1 }}
          >
            <Grid item xs={item?.[3] ? 7 : 12}>
              <CurrencyField
                fullWidth
                variant="outlined"
                margin="dense"
                InputLabelProps={{ shrink: true }}
                label={item?.[1]}
                disabled={isCampoFinanceiroDisabled}
                size="small"
                value={
                  values?.formasPagamento?.find(
                    (v) =>
                      v.unic === item?.[0]?.[1] &&
                      v.idFormaPagamento === item?.[0]?.[0],
                  )?.vlPago || 0
                }
                onChange={(val) => {
                  const totalOutros =
                    values?.formasPagamento
                      ?.filter((v) => v.unic !== item?.[0]?.[1])
                      ?.reduce((acc, v) => acc + (v.vlPago || 0), 0) || 0

                  if (totalOutros + val > totalGeral) {
                    setWarning(
                      'O valor total das formas de pagamento não pode ultrapassar o total a pagar',
                    )
                  }

                  setFieldValue(
                    'formasPagamento',
                    values?.formasPagamento?.map((v) =>
                      v?.unic === item?.[0]?.[1] ? { ...v, vlPago: val } : v,
                    ),
                  )
                }}
                error={!!errors?.formasPagamento?.[index]?.vlPago}
              />
            </Grid>
            {item?.[3] && (
              <Grid item xs={5}>
                <TextField
                  fullWidth
                  variant="outlined"
                  type="number"
                  margin="dense"
                  label="Parcelas"
                  size="small"
                  disabled={isCampoFinanceiroDisabled}
                  value={
                    values?.formasPagamento?.find(
                      (v) =>
                        v.unic === item?.[0]?.[1] &&
                        v.idFormaPagamento === item?.[0]?.[0],
                    )?.qtParcelas
                  }
                  onChange={(e) => {
                    const val = e?.target?.value
                    setFieldValue(
                      'formasPagamento',
                      values?.formasPagamento?.map((v) =>
                        v?.unic === item?.[0]?.[1]
                          ? { ...v, qtParcelas: val ? Number(val) : '' }
                          : v,
                      ),
                    )
                  }}
                  error={!!errors?.formasPagamento?.[index]?.qtParcelas}
                />
              </Grid>
            )}
          </Grid>
        ))}
      </Box>

      <Divider />

      <Box sx={{ px: 2, py: 2 }}>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <TextField
              fullWidth
              variant="outlined"
              margin="dense"
              InputLabelProps={{ shrink: !!values?.prDesconto }}
              label="Porcentagem (%)"
              type="number"
              size="small"
              value={values?.prDesconto || null}
              disabled={isDisabled || totalGeral <= 0}
              onChange={(e) => {
                const pr = parseFloat(e.target.value)
                const vlCalculado = (pr / 100) * valorTotalTabelaBase
                setFieldValue('prDesconto', pr || '')
                setFieldValue('vlDesconto', vlCalculado)
              }}
              onFocus={(e) =>
                e.target.value === '0' && setFieldValue('prDesconto', '')
              }
              error={touched?.prDesconto && !!errors.prDesconto}
              helperText={touched?.prDesconto && errors.prDesconto}
            />
          </Grid>
          <Grid item xs={6}>
            <CurrencyField
              fullWidth
              variant="outlined"
              margin="dense"
              label="Desconto (R$)"
              size="small"
              disabled={isDisabled || totalGeral <= 0}
              value={values?.vlDesconto || 0}
              onChange={(v) => {
                const vl = v || 0
                const prCalculado =
                  valorTotalTabelaBase > 0
                    ? (vl / valorTotalTabelaBase) * 100
                    : 0
                setFieldValue('vlDesconto', vl)
                setFieldValue('prDesconto', prCalculado.toFixed(2))
              }}
              helperText={
                touched?.vlDesconto && errors.vlDesconto
                  ? errors.vlDesconto
                  : ''
              }
              error={touched?.vlDesconto && !!errors.vlDesconto}
            />
          </Grid>
          <Divider />
          <Grid item xs={12}>
            <TextField
              label="Observação"
              fullWidth
              size="small"
              multiline
              rows={3}
              name="dsObservacoes"
              value={values.dsObservacoes || ''}
              onChange={handleChange}
              disabled={isSubmitting || isFinalizado}
            />
          </Grid>
        </Grid>
      </Box>

      <Divider />

      <Box
        sx={{
          px: 2,
          py: 1.5,
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <IconButton
          title="Imprimir PDF"
          onClick={() => onImprimir(values, setSubmitting)}
          disabled={isSubmitting}
        >
          <BsPrinter />
        </IconButton>
        <Button
          color="inherit"
          variant="outlined"
          disabled={isDisabled}
          onClick={() => onSalvarRascunho(values, setSubmitting)}
          sx={{ textTransform: 'none', height: 45 }}
        >
          Salvar rascunho
        </Button>
        <Button
          color="primary"
          variant="contained"
          disabled={isDisabled}
          onClick={submitForm}
          sx={{
            textTransform: 'none',
            fontWeight: 'bold',
            height: 45,
            px: 3,
          }}
        >
          Registrar Pedido
        </Button>
        {isRascunho && (
          <IconButton
            title="Excluir rascunho"
            onClick={onExcluirRascunho}
            disabled={isDisabled}
          >
            <MdDelete />
          </IconButton>
        )}
      </Box>
    </Paper>
  )
}

export default ResumoFinal
